import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Text, TextLink, Tooltip } from '@modusign/design-system';

interface AddressBookSearchInputHelpButtonProps {
  isTooltipOpen: boolean;
  onClick: () => void;
}

export default function AddressBookSearchInputHelpButton({
  isTooltipOpen,
  onClick,
}: AddressBookSearchInputHelpButtonProps) {
  return (
    <Tooltip
      content={
        <Text as="p" color="textNeutralUltraLight" fontSize="sm" sx={{ width: '140px' }}>
          설정의{' '}
          <TextLink href="/settings/address-book" mode="night" target="_blank">
            주소록
          </TextLink>
          에서 연락처를 관리할 수 있습니다.
        </Text>
      }
      isOpen={isTooltipOpen}
      placement="top-end"
    >
      <Box
        as="button"
        color="iconNeutralBase"
        height="18px"
        type="button"
        width="18px"
        onClick={onClick}
      >
        <FontAwesomeIcon icon={faQuestionCircle} />
      </Box>
    </Tooltip>
  );
}
